import { createSelector } from '@/factory'
import { constant } from './constant'

const getTableWrapper = () => createSelector<HTMLElement>({ selector: constant.selector.tableWrapper })

export const getComponents = () => ({
	tableWrapper: getTableWrapper(),
})
